module.exports = __webpack_public_path__ + "img/AC725C_2E1610_663E31_E78F6B-256px.d189a03c.png";